/**
 * A banner with arbitrary content that can be dismissed by the user.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Close from '../../assets/svg/TinyClose';
import BlankButton from './Buttons/BlankButton';
import { DESKTOP_START_QUERY } from '../../styling/mixins/responsive';

const Box = styled.div`
  background-color: ${({ color }) => color};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;

  padding: ${props =>
    props.align === 'left' ? '0.75rem 2.5rem 0.75rem 1rem' : '0.75rem 2.5rem'};
  text-align: ${props => props.align};

  @media (${DESKTOP_START_QUERY}) {
    padding: ${props =>
      props.align === 'left' ? '0.75rem 2.5rem 0.75rem 1rem' : '1rem 2.5rem'};
  }
`;

const MessageBox = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
`;

const CloseX = styled(Close)`
  width: 1.5rem;
  height: 1.5rem;
  // Doing some hacky styles here to get this to fit
  // into the corner as nicely as possible
  margin-top: -5px;
  margin-right: -4px;
`;

const Button = styled(BlankButton)`
  height: 2.5rem;
  width: 2.5rem;
  position: absolute;
  right: 0;
  top: 0;
`;

export default class CloseBox extends Component {
  /**
   * propTypes
   * @property {any} children The message to display in the box (may contain links).
   * @property {function} dismiss A function that will dismiss the box.
   */

  static propTypes = {
    align: PropTypes.string,
    closeable: PropTypes.bool,
    children: PropTypes.any.isRequired,
    dismiss: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired,
    strokeColor: PropTypes.string,
  };

  static defaultProps = {
    align: 'center',
    closeable: true,
  };

  render() {
    const {
      align,
      dismiss,
      children,
      closeable,
      color,
      strokeColor,
    } = this.props;

    return (
      <Box color={color} align={align}>
        <MessageBox>{children}</MessageBox>
        {closeable ? (
          <Button onClick={dismiss}>
            <CloseX strokeColor={strokeColor} />
          </Button>
        ) : null}
      </Box>
    );
  }
}
